angular.module('env.i18n.kendoLocalization', [])

    .run(function (uiLocalization, kendoMessages) {
        uiLocalization.events.on('changed', function () {
            kendoMessages.update();
        });
    })

    .service('kendoLocalization', function ($q, $http, EventingMixin, LocaleName) {
        var _this = this;
        _this = _.extend(_this, new EventingMixin(['changed']));

        /**
         * Cache of available languages
         * @type {Array}
         */
        var languagesList;

        /**
         * Default language
         * @type {string}
         */
        var defaultLanguage = "en-GB";

        /**
         * Current language
         * @type {string}
         */
        var currentLanguage;

        /**
         * Get list of supported angular languages
         * @returns {!Promise} promise
         */
        _this.getLanguagesList = function () {
            var deferred = $q.defer();
            if (languagesList) {
                deferred.resolve(languagesList);
            } else {
                $http.get('translations/availableKendoLocales.json')
                    .then(function (resp) {
                        try {
                            languagesList = resp.data;
                            deferred.resolve(languagesList);
                        } catch (err) {
                            languagesList = null;
                            deferred.reject(err);
                        }
                    }, function (err) {
                        deferred.reject(err);
                    });
            }

            return deferred.promise;
        };

        /**
         * Set current language for kendo localization
         * @param {string} lang - code of the language
         * @returns {!Promise} promise
         */
        _this.setCurrentLanguage = function (lang) {
            var deferred = $q.defer();

            _this.getLanguagesList().then(
                function (langList) {
                    // get the most suitable language code
                    var languageCode = (new LocaleName(lang)).getMostSuitableLanguage(langList) || defaultLanguage;

                    $http.get('vendor/kendo-om-custom/js/cultures/kendo.culture.' + languageCode + '.min.js')
                        .then(function (resp) {
                            eval(resp.data);
                            kendo.culture(languageCode);
                            currentLanguage = languageCode;
                            _this.events.raise('changed', {language: languageCode});
                            deferred.resolve(languageCode);
                        },
                        function (err) {
                            deferred.reject(err);
                        });
                },
                function (err) {
                    deferred.reject(err);
                }
            );

            return deferred.promise;
        };

        /**
         * Get current ui localization language
         * @returns {string|undefined} current kendo localization language code
         */
        _this.getCurrentLanguage = function () {
            return currentLanguage;
        };

        return _this;
    })

;